import { render } from "./govschememaster.vue?vue&type=template&id=10e7b6a3&scoped=true"
import script from "./govschememaster.vue?vue&type=script&lang=js"
export * from "./govschememaster.vue?vue&type=script&lang=js"

import "./govschememaster.vue?vue&type=style&index=0&id=10e7b6a3&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\know_your_doctor\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e7b6a3"]])

export default __exports__